export default "__VITE_ASSET__fMox5szS__"